// extracted by mini-css-extract-plugin
export var wrapper = "carousel-module--wrapper--2HlAI";
export var swiperContainer = "carousel-module--swiperContainer--2SO_A";